/** Retain the exact command after a lost acknowledgement. Never infer that it failed. */
export class OperationRetry {
  private attempt?: {operation:string; input:unknown};
  private running=false;
  get pending(){return !!this.attempt}
  reset(){this.attempt=undefined;this.running=false}
  async run<T>(send:(operation:string,input:unknown)=>Promise<T>, next?:{operation:string;input:unknown}):Promise<T>{
    if(this.running)throw new Error('Handlingen afventer allerede svar.');
    if(this.attempt&&next)throw new Error('Afklar først den handling, der afventer svar.');
    const attempt=this.attempt??(next?structuredClone(next):undefined);
    if(!attempt)throw new Error('Der er ingen handling at gentage.');
    this.attempt=attempt;this.running=true;
    try{
      const result=await send(attempt.operation,structuredClone(attempt.input));
      if(this.attempt!==attempt)throw new Error('Adgangen er ændret. Hent indholdet igen.');
      this.attempt=undefined;return result;
    }catch(error){
      const code=(error as {code?:string})?.code;
      if(this.attempt===attempt&&['forbidden','invalid','conflict','unsupported','not_found'].includes(code??''))this.attempt=undefined;
      throw error;
    }finally{if(this.attempt===attempt||!this.attempt)this.running=false}
  }
}
